'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = {
  'btn:save': 'Save',
  'btn:cancel': 'Cancel',
  'btn:clear': 'Clear'
};